import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Keyboard from '../../../services/keyboardShortcuts';
import { TabGroup, TabList, Tab, TabContent, TabData } from './TabGroup.styles';
import { configActions, gridtoolsActions } from '../../../redux/actions';

export default (props) => {

    const dispatch = useDispatch();
    const [activeTab,setActiveTab] = useState(0);
    const jumpToTab = useSelector(state => state.configState.jumpToTab);
    const isOwner = useSelector(state => state.authState.isOwner);
    const selectedChar = useSelector(state => state.charactersState.selectedCharId);

    const ChangeTab = useCallback((index) => {
        dispatch(configActions.jumpToTab(index));
    },[dispatch]);

    useEffect(() => {
        let keyTab1 = () => {
            ChangeTab(0);
            return true;
        }
        let keyTab2 = () => {
            ChangeTab(1);
            return true;
        }
        let keyTab3 = () => {
            ChangeTab(2);
            return true;
        }
        let keyTab4 = () => {
            ChangeTab(3);
            return true;
        }
        let keyTab5 = () => {
            if (isOwner) {
                ChangeTab(4);
            }
            return true;
        }
        let keyTab6 = () => {
            ChangeTab(5);
            return true;
        }
        
        Keyboard.register({alt: true, key:'1'}, keyTab1);
        Keyboard.register({alt: true, key:'2'}, keyTab2);
        Keyboard.register({alt: true, key:'3'}, keyTab3);
        Keyboard.register({alt: true, key:'4'}, keyTab4);
        Keyboard.register({alt: true, key:'5'}, keyTab5);
        Keyboard.register({alt: true, key:'6'}, keyTab6);

        return () => {
            Keyboard.unregister({alt: true, key:'1'}, keyTab1);
            Keyboard.unregister({alt: true, key:'2'}, keyTab2);
            Keyboard.unregister({alt: true, key:'3'}, keyTab3);
            Keyboard.unregister({alt: true, key:'4'}, keyTab4);
            Keyboard.unregister({alt: true, key:'5'}, keyTab5);
            Keyboard.unregister({alt: true, key:'6'}, keyTab6);
        }
    }, [isOwner, ChangeTab]);

    useEffect(() => {
        if (selectedChar) {
            dispatch(configActions.jumpToTab(2));
        }
    }, [selectedChar, dispatch]);

    useEffect(() => {
        setActiveTab(jumpToTab);
        dispatch(gridtoolsActions.setToolMode('none'));
    }, [jumpToTab, dispatch]);

    return <TabGroup>
        <TabList>
            { props.children.map((tab, index) => (
                <Tab className={(activeTab === index ? 'active ' : '') + (tab.props.hidden ? 'hidden ' : '') } key={index} onClick={()=>{ChangeTab(index)}}>{tab.props.children}</Tab>
            )) }
        </TabList>
        <TabContent className="sidemenu scrollbar">
            { props.children.map((tab, index) => (
                <TabData className={activeTab === index ? 'active' : '' } key={index}>
                    { tab.props.component }
                </TabData>
            )) }
        </TabContent>
    </TabGroup>
};